
import DrawBase from "./DrawBase"
import EditBillboard from "./EditBillboard"
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js"
class DrawBillboard extends DrawBase {
    constructor(options) {
        super(options);
    }

    leftDoubleClick() {

    }

    loadPlot(data) {
        var position = JSON.parse(data.editPositions);
        position= new Cesium.Cartesian3(position.x, position.y,position.z)
        this.plot = this.createBillboardbyId(position,data.markId);
        this.plot.label = {
            show: true,
            text: "注记",
            scale: 1,
            showBackground: false,
            backgroundColor: new Cesium.Color(0.165, 0.165, 0.165, 0.8),
            backgroundPadding: new Cesium.Cartesian2(7, 5),
            pixelOffset: new Cesium.Cartesian2(0, -40),
            fillColor: Cesium.Color.WHITE
        };

        this.plot.billboard = {
            image: this.plot.billboard.image,
            show: true,
            scale: 1,
            pixelOffset: new Cesium.Cartesian2(0, 0),
            color: Cesium.Color.WHITE,
            rotation: 0,
            width: 32,
            height: 44
        }
        this.plot.extTag = "BH_Feature"; //添加类型标识
        this.plot.extType = "billboard_Nor"
        this.plot.typeName = "图标";
        this.editHelp = new EditBillboard(this.options); //初始化编辑类
        this.editHelp.callback = this.callback;
        this.destroy();
        // if(!data.onlyRead){
        //     this.startEdit();
        // }
        
        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr), this.plot, "billboard")
        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr).formLabel, this.plot, "label")
        this.startEdit();
        return this.plot;
    }

    //左键
    leftClick(evt) {
        var position = this.getCatesian3FromPX(evt.position);
        this.plot = this.createBillboard(position, {
            image: this.options.image || "data/img/marker/mark2.png",
        });
        this.plot.label = {
            show: true,
            text: "注记",
            scale: 1,
            showBackground: false,
            backgroundColor: new Cesium.Color(0.165, 0.165, 0.165, 0.8),
            backgroundPadding: new Cesium.Cartesian2(7, 5),
            pixelOffset: new Cesium.Cartesian2(0, -40),
            fillColor: Cesium.Color.WHITE
        };

        this.plot.billboard = {
            image: this.plot.billboard.image,
            show: true,
            scale: 1,
            pixelOffset: new Cesium.Cartesian2(0, 0),
            color: Cesium.Color.WHITE,
            rotation: 0,
            width: 32,
            height: 44
        }

        this.plot.extTag = "BH_Feature"; //添加类型标识
        this.plot.extType = "billboard_Nor"
        this.plot.typeName = "图标";

        this.editHelp = new EditBillboard(this.options); //初始化编辑类
        this.editHelp.callback = this.callback;
        this.entities.push(this.plot);
        this.callback && this.callback(this.plot);
        this.destroy();
        this.startEdit();
    }
}

export default DrawBillboard;